import { useUser } from "context/user";
import { UserRole } from "types/user";
import { Session, User } from "types";
import {
    GetCommaSeperatedClientList,
    GetClientFirstNameList,
    GetClientLastNameList,
    GetClientUserNameList
} from "utils/user";


const useNames = () => {
    const { user } = useUser()!;

    const firstNames = (session: Session) => {
        const users = session?.participants;
        if (user.id == session.coach_id || user.privs >= UserRole.Coach) {
            const list = users.filter((p) => p.id != user.id);
            return GetClientFirstNameList(list, user);
        }
        else return session.coach.first_name;
    }

    const lastNames = (session: Session) => {
        const users = session?.participants;
        if (user.id == session.coach_id || user.privs >= UserRole.Coach) {
            const list = users.filter((p) => p.id != user.id);
            return GetClientLastNameList(list, user);
        }
        else return session.coach.last_name;
    }

    const userNames = (session: Session) => {
        const users = session?.participants;
        if (user.id == session.coach_id || user.privs >= UserRole.Coach) {
            const list = users.filter((p) => p.id != user.id);
            return GetClientLastNameList(list, user);
        }
        else return session.coach.username;
    }

    const commaSeparatedList = (session: Session) => {
        const users = session?.participants;
        if (user.id == session.coach_id || user.privs >= UserRole.Coach) {
            const list = users.filter((p) => p.id != user.id);
            return GetCommaSeperatedClientList(list, user);
        }
        else return `${session.coach.first_name} ${session.coach.last_name}`;
    }

    const role = user.privs < UserRole.Coach ?
        "Client" :
        "Coach";

    const counterpart = user.privs >= UserRole.Coach ?
        "Client" :
        "Coach";

    return {
        firstNames,
        lastNames,
        userNames,
        commaSeparatedList,
        role,
        counterpart
    }
}

export default useNames;
